/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file.
 * This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions
 * and limitations under the License.
 */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// @ts-nocheck
import Vue from 'vue';
import { components } from 'aws-amplify-vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import HighchartsVue from 'highcharts-vue';
//
import Vue2Filters from 'vue2-filters';
import Vuelidate from 'vuelidate';
import router from '@/router';
import App from '@/App';
import store from '@/store/store';
import configAxiosInterceptors from './helpers/interceptors';
import configSentry from '@/plugins/sentry';
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

Vue.config.productionTip = false;

Vue.use(Vue2Filters);
Vue.use(Vuetify);
Vue.use(HighchartsVue);
Vue.use(Vuelidate);
Vue.use(VueMoment, {
  moment,
});

Vue.filter('toCurrency', (value) => {
  if (typeof value !== 'number') {
    return value;
  }
  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  });

  return formatter.format(value);
});

configAxiosInterceptors();
configSentry();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App,
    ...components,
  },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.ts